import React from 'react'
import { ConnectedRouter } from 'react-router-redux'
import { Route, Switch } from 'react-router'
import createHistory from 'history/createBrowserHistory'

import App from './App';
import Login from '../containers/Login';
import PrivateRoute from '../containers/PrivateRoute';

import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import red from '@material-ui/core/colors/red';
import pink from '@material-ui/core/colors/pink';

const history = createHistory();

const theme = createMuiTheme({
  palette: {
    primary: {
      light: blue[300],
      main: blue[500],
      dark: blue[700],
    },
    secondary: {
      light: pink[300],
      main: pink[500],
      dark: pink[700],
    },
    error: red,
    action: {
      active: '#000',
      disabled: '#fff',
      disabledBackground: blue[900],
      cursor: 'disabled',
      selected: blue[200],
    },
  },

  typography: {
    fontSize: 16,
    useNextVariants: true,
  },

  overrides: {
    MuiCheckbox: {
      root: {
        "&$disabled": {
          color: '#9e9e9e!important'
        },
        disabled: {},
      }
    },
    MuiFormControl: {
      root: {
        padding: '0.5rem 0'
      },

    },
    MuiFormLabel: {
      root: {
        color: '#0072b4'
      },
    },
    MuiInput: {
      root: {
        color: '#0072B4',
      },
      input: {
        borderBottom: '0!important',
        margin: '0!important',
        '&:focus': {
          boxShadow: 'none!important',
          borderBottom: '0!important',
        },
      },
      underline: {
        '&:after': {
          backgroundColor: '#00a5ff',
          borderBottom: '2px solid #0072b47a'
        },
        '&:before': {
          backgroundColor: '#0072B4',
          height: '1px',
          borderBottom: '1px solid #0072b47a'

        },
        '&:hover': {
          '&:before': {
            backgroundColor: '#e3f5ff!important',
            borderBottom: '2px solid #2196F3!important'
          }
        }
      },

    },
    MuiPickersDay: {
      "&$selected": {
        "backgroundColor": "#0288d1"
      }
    },
    MuiDialogTitle: {
      root: {
        boxSizing: 'border-box'
      }
    }
  },

});

const Root = () => (
  <ConnectedRouter history={history}>
    <MuiThemeProvider theme={theme}>
      <Switch>
        <Route exact path="/login" component={Login} />
        <PrivateRoute path="/" component={App} />
      </Switch>
    </MuiThemeProvider>
  </ConnectedRouter>
)

export default withStyles(theme)(Root)


// WEBPACK FOOTER //
// ./src/components/Root.js